export class ModeloGps {
    dataCriacao: string;
    dataUltimaAlteracao: string;
    ativo: boolean;
    modelo: string;
    senha: string;
    numero: string;
    protocolo: string;
    id: number;
    usuarioCriacaoId: number;
    usuarioUltimaAlteracaoId: number;
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/modelos-gps/shared/modelo-gps.model.ts
 **/